var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5829 10.457H16.8948L14.4051 8.01611H5.17598C4.84583 8.01611 4.5292 8.14469 4.29575 8.37357C4.0623 8.60244 3.93115 8.91286 3.93115 9.23653V28.7632C3.93115 29.0869 4.0623 29.3973 4.29575 29.6262C4.5292 29.8551 4.84583 29.9837 5.17598 29.9837H27.5829C27.913 29.9837 28.2297 29.8551 28.4631 29.6262C28.6966 29.3973 28.8277 29.0869 28.8277 28.7632V11.6774C28.8277 11.3537 28.6966 11.0433 28.4631 10.8144C28.2297 10.5855 27.913 10.457 27.5829 10.457ZM12.7181 15.3388H20.0406V20.1278C20.0406 20.9989 19.6324 21.8113 18.9541 22.2947L16.3794 24.1258L13.8046 22.2947C13.4703 22.0568 13.1963 21.7346 13.0067 21.3566C12.8172 20.9786 12.7181 20.5565 12.7181 20.1278V15.3388Z",
    fill: "#8AABA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/icon_data.0a6f53ed4b4bbd07a01ac7e82588ff98.svg";
export { ForwardRef as ReactComponent };